<template>
  <div id="app">
    <router-view />
    <!-- 启动欢迎页：有启用封面图时全屏覆盖，向上滑动或点击进入 -->
    <welcome v-if="showWelcome" :image-url="welcomeImage" @dismissed="onDismissed" />
  </div>
</template>

<script>
import { apiHomeCoverActive } from './api'
import Welcome from './views/Welcome.vue'

export default {
  name: 'App',
  components: { Welcome },
  data() {
    return {
      showWelcome: false,
      welcomeImage: ''
    }
  },
  created() {
    this.loadWelcomeCover()
  },
  methods: {
    async loadWelcomeCover() {
      try {
        const r = await apiHomeCoverActive()
        if (r && r.imageUrl) {
          this.welcomeImage = r.imageUrl
          this.showWelcome = true
        }
      } catch (e) {
        // 静默失败：欢迎页不影响主流程
      }
    },
    onDismissed() {
      this.showWelcome = false
      // 滑掉启动页进入首页时，强制滚动到顶部（启动页是覆盖层不触发路由跳转，
      // 否则会沿用进入前的滚动位置，导致 banner 顶部看不见）
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  padding: 0;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #333;
}
a {
  text-decoration: none;
  color: inherit;
}
img {
  display: block;
  max-width: 100%;
}
</style>
